export default "__VITE_ASSET__CAiLWi3u__"